// 金桔影院 首页本地展示数据（静态示例，非真实接口数据）

export const heroHighlights = [
  { label: '今日新增', value: '38 部' },
  { label: '片单收录', value: '1,286 部' },
  { label: '影迷打分', value: '24.6 万' },
];

export const editorPicks = [
  {
    id: 'ep-1',
    rank: '01',
    title: '长夜将尽的列车',
    summary: '一列开往边境的夜车上，七个陌生人彼此隐瞒着同一段旧事，直到天亮前谁都无法下车。',
    tag: '本期主推',
    meta: '2025 · 剧情 / 悬疑 · 片长 132 分钟',
    score: '8.7',
  },
  {
    id: 'ep-2',
    rank: '02',
    title: '半岛的夏日来信',
    summary: '退休邮差替陌生人送达最后一封信，沿着海岸线走完了一整个不肯结束的夏天。',
    tag: '编辑私藏',
    meta: '2024 · 剧情 / 家庭 · 片长 118 分钟',
    score: '8.4',
  },
  {
    id: 'ep-3',
    rank: '03',
    title: '十二级台阶',
    summary: '一桩十二年前的旧案，十二级台阶，恰好够一个人把真相重新走一遍。',
    tag: '口碑回升',
    meta: '2025 · 犯罪 / 悬疑 · 片长 126 分钟',
    score: '8.2',
  },
  {
    id: 'ep-4',
    rank: '04',
    title: '橘子汽水的味道',
    summary: '小镇少年在最后一个暑假里学会告别，也学会了把喜欢的人写进信里却不寄出去。',
    tag: '青春单元',
    meta: '2023 · 剧情 / 青春 · 片长 104 分钟',
    score: '7.9',
  },
];

export const latestMovies = [
  {
    id: 'lm-1',
    title: '雾港谜案',
    summary: '港口城市的连环失踪案，把所有线索都指向了一座早已停用的灯塔。',
    date: '10月09日',
    genre: '悬疑 / 犯罪',
    score: '8.1',
  },
  {
    id: 'lm-2',
    title: '山河慢',
    summary: '一支民间放映队穿越六个乡镇，用旧胶片把快被遗忘的县城故事重新点亮。',
    date: '10月08日',
    genre: '纪录 / 人文',
    score: '8.6',
  },
  {
    id: 'lm-3',
    title: '借我一整个冬天',
    summary: '两个在异乡过冬的年轻人，用一张彼此都舍不得还的借条维系着关系。',
    date: '10月06日',
    genre: '爱情 / 剧情',
    score: '7.8',
  },
  {
    id: 'lm-4',
    title: '末日前的便利店',
    summary: '世界只剩七天，一间便利店照常营业，收银台前排队的人各有各的告别方式。',
    date: '10月05日',
    genre: '科幻 / 温情',
    score: '8.0',
  },
  {
    id: 'lm-5',
    title: '旧钟楼的风声',
    summary: '修复古钟的匠人发现，钟声里藏着一份跨越三代的家族秘密。',
    date: '10月03日',
    genre: '剧情 / 家庭',
    score: '8.3',
  },
  {
    id: 'lm-6',
    title: '荒野邮局',
    summary: '戈壁深处唯一的邮局，替留下来的人保管着寄不出去的信。',
    date: '10月01日',
    genre: '文艺 / 公路',
    score: '7.7',
  },
];

export const rankingBoards = [
  {
    key: 'hot',
    name: '热播榜',
    desc: '按站内近期观看与讨论热度排序，反映当下大家正在看的电影。',
    items: [
      { rank: 1, title: '长夜将尽的列车', meta: '剧情 / 悬疑', score: '9.1', trend: 'up' },
      { rank: 2, title: '雾港谜案', meta: '悬疑 / 犯罪', score: '8.8', trend: 'up' },
      { rank: 3, title: '末日前的便利店', meta: '科幻 / 温情', score: '8.6', trend: 'flat' },
      { rank: 4, title: '山河慢', meta: '纪录 / 人文', score: '8.5', trend: 'down' },
      { rank: 5, title: '十二级台阶', meta: '犯罪 / 悬疑', score: '8.4', trend: 'up' },
      { rank: 6, title: '借我一整个冬天', meta: '爱情 / 剧情', score: '8.1', trend: 'down' },
    ],
  },
  {
    key: 'word',
    name: '口碑榜',
    desc: '综合影迷评分与长评质量，选出经得起细看的高分佳作。',
    items: [
      { rank: 1, title: '山河慢', meta: '纪录 / 人文', score: '9.3', trend: 'flat' },
      { rank: 2, title: '长夜将尽的列车', meta: '剧情 / 悬疑', score: '9.0', trend: 'up' },
      { rank: 3, title: '旧钟楼的风声', meta: '剧情 / 家庭', score: '8.8', trend: 'up' },
      { rank: 4, title: '橘子汽水的味道', meta: '剧情 / 青春', score: '8.6', trend: 'down' },
      { rank: 5, title: '半岛的夏日来信', meta: '剧情 / 家庭', score: '8.5', trend: 'flat' },
      { rank: 6, title: '荒野邮局', meta: '文艺 / 公路', score: '8.2', trend: 'down' },
    ],
  },
  {
    key: 'new',
    name: '新片榜',
    desc: '近期上新影片里表现最亮眼的一批，适合想追新的观众。',
    items: [
      { rank: 1, title: '雾港谜案', meta: '悬疑 / 犯罪', score: '8.9', trend: 'up' },
      { rank: 2, title: '末日前的便利店', meta: '科幻 / 温情', score: '8.7', trend: 'up' },
      { rank: 3, title: '借我一整个冬天', meta: '爱情 / 剧情', score: '8.3', trend: 'flat' },
      { rank: 4, title: '长夜将尽的列车', meta: '剧情 / 悬疑', score: '8.2', trend: 'up' },
      { rank: 5, title: '荒野邮局', meta: '文艺 / 公路', score: '8.0', trend: 'down' },
      { rank: 6, title: '旧钟楼的风声', meta: '剧情 / 家庭', score: '7.9', trend: 'flat' },
    ],
  },
];

export const topRated = [
  {
    id: 'tr-1',
    title: '山河慢',
    oneLiner: '把正在消失的县城，一帧一帧地留在胶片上。',
    genre: '纪录 / 人文',
    year: '2025',
    score: '9.3',
  },
  {
    id: 'tr-2',
    title: '长夜将尽的列车',
    oneLiner: '天亮之前，没有一个秘密能留在车厢里。',
    genre: '剧情 / 悬疑',
    year: '2025',
    score: '9.0',
  },
  {
    id: 'tr-3',
    title: '旧钟楼的风声',
    oneLiner: '钟声响了七十年，替一个家族说了三代人的话。',
    genre: '剧情 / 家庭',
    year: '2024',
    score: '8.8',
  },
  {
    id: 'tr-4',
    title: '橘子汽水的味道',
    oneLiner: '那个夏天很吵，只有喜欢你的声音很轻。',
    genre: '剧情 / 青春',
    year: '2023',
    score: '8.6',
  },
  {
    id: 'tr-5',
    title: '半岛的夏日来信',
    oneLiner: '一封迟到了二十年的信，走完了一整段海岸线。',
    genre: '剧情 / 家庭',
    year: '2024',
    score: '8.5',
  },
  {
    id: 'tr-6',
    title: '十二级台阶',
    oneLiner: '真相一直就在楼下，只是没人愿意重新走一遍。',
    genre: '犯罪 / 悬疑',
    year: '2025',
    score: '8.4',
  },
];

export const hiddenGems = [
  {
    id: 'hg-1',
    title: '春分那天下了雪',
    summary: '没有明星也没有大场面，却把一个小镇的中年困境拍得温柔又克制。',
    region: '中国大陆',
    year: '2022',
  },
  {
    id: 'hg-2',
    title: '修表匠的最后一个客人',
    summary: '四十分钟不到的短章长片，一间铺子、两个人，把时间说得比钟表更准。',
    region: '中国大陆',
    year: '2021',
  },
  {
    id: 'hg-3',
    title: '海边的旧放映室',
    summary: '被游客遗忘的放映室每晚只放一部电影，观众有时只有一个。',
    region: '中国香港',
    year: '2023',
  },
  {
    id: 'hg-4',
    title: '向南五百公里',
    summary: '一辆报废的货车和一对和解不了的父子，一起走完了这段路。',
    region: '中国大陆',
    year: '2020',
  },
];

export const discussions = [
  {
    id: 'd-1',
    author: '看片不睡的阿柚',
    initials: '柚',
    time: '12 分钟前',
    movie: '长夜将尽的列车',
    content: '二刷才注意到，车厢里每个人的行李都对应着他们隐瞒的那段旧事，导演是真的把伏笔埋到了行李牌上。你们有没有发现那个红色手提箱？',
    likes: 428,
    replies: 63,
  },
  {
    id: 'd-2',
    author: '周末补片计划',
    initials: '周',
    time: '48 分钟前',
    movie: '山河慢',
    content: '这部纪录片适合关掉弹幕、戴耳机慢慢看。放映队在乡镇挂幕布的那一段，我直接把进度条拖回去看了三遍。',
    likes: 315,
    replies: 41,
  },
  {
    id: 'd-3',
    author: '只挑冷门的橘子',
    initials: '橘',
    time: '2 小时前',
    movie: '修表匠的最后一个客人',
    content: '求同类型推荐！就喜欢这种小成本、对话多、几乎不配乐但特别耐看的片子，金桔影院的冷门宝藏分类简直是给我准备的。',
    likes: 259,
    replies: 88,
  },
  {
    id: 'd-4',
    author: '夜班影评人',
    initials: '夜',
    time: '5 小时前',
    movie: '雾港谜案',
    content: '结尾的灯塔镜头和开头是同一个机位，只是潮水退了下去。这种首尾呼应的设计，让整部片子的宿命感一下就立住了。',
    likes: 197,
    replies: 34,
  },
];

export const topicCollections = [
  {
    id: 'tc-1',
    title: '高分剧情片单',
    desc: '评分靠前、经得起细看的剧情佳作合集，适合想认真看一部好电影的时候。',
    count: 42,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20tangerine%20toned%20abstract%20still%20life%20of%20stacked%20vintage%20film%20reels%20and%20soft%20golden%20light%20beams%20on%20a%20cream%20textured%20surface%2C%20minimal%20editorial%20composition%20with%20generous%20negative%20space%2C%20rich%20warm%20contrast%2C%20artful%20cinema%20atmosphere&width=800&height=600&seq=jinju-topic-highscore-01&orientation=landscape',
  },
  {
    id: 'tc-2',
    title: '冷门宝藏发掘',
    desc: '没多少热度、但看完想立刻安利给朋友的片子，都在这个合集里。',
    count: 28,
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20warm%20toned%20abstract%20scene%20of%20an%20old%20film%20projector%20casting%20soft%20golden%20beams%20onto%20a%20dusty%20cream%20wall%2C%20scattered%20small%20kumquat%20fruits%20nearby%2C%20warm%20amber%20and%20terracotta%20palette%2C%20minimal%20artistic%20composition%2C%20editorial%20photography%2C%20no%20blue%20or%20purple&width=800&height=600&seq=jinju-topic-hidden-02&orientation=landscape',
  },
  {
    id: 'tc-3',
    title: '悬疑犯罪专区',
    desc: '从旧案翻查到反转结局，一次把想烧脑的片子挑齐。',
    count: 36,
    image:
      'https://readdy.ai/api/search-image?query=Atmospheric%20warm%20brown%20and%20crimson%20reed%20abstract%20composition%20of%20an%20empty%20directors%20chair%20and%20a%20single%20lit%20bulb%20against%20a%20moody%20cream%20backdrop%2C%20long%20shadow%2C%20muted%20terracotta%20palette%2C%20minimal%20editorial%20photography%20with%20cinematic%20tension%2C%20no%20blue%20or%20purple&width=800&height=600&seq=jinju-topic-suspense-03&orientation=landscape',
  },
];

export const heroImage =
  'https://readdy.ai/api/search-image?query=Warm%20tangerine%20and%20amber%20toned%20artistic%20still%20life%20featuring%20a%20vintage%20film%20projector%20and%20glossy%20orange%20kumquat%20fruits%20arranged%20on%20a%20soft%20cream%20surface%2C%20golden%20afternoon%20light%20and%20long%20gentle%20shadows%2C%20minimal%20editorial%20composition%20with%20generous%20negative%20space%2C%20rich%20warm%20harmonious%20palette%2C%20high%20detail%2C%20no%20blue%20or%20purple&width=1200&height=1400&seq=jinju-hero-main-01&orientation=portrait';